/** Colors representing each score category */
export enum ScoreColor {
  /** Extreme */
  red = '#E53935',
  /** High */
  orange = '#FB8C00',
  /** Medium */
  yellow = '#FBC02D',
  /** Low */
  green = '#CDDC39',
  /** No Score */
  noScore = '#CECECE',
}
